import { ICreateTeaserState } from './createTeaserContext';
import { CreateTeaserActionTypes, TCreateTeaserAction } from './createTeaserActions';

export const createTeaserReducer = (state: ICreateTeaserState, action: TCreateTeaserAction): ICreateTeaserState => {
	switch (action.type) {
		case CreateTeaserActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateTeaserActionTypes.SET_FILE:
			return {
				...state,
				fileId: action.payload.fileId,
				sourceUrlLocally: action.payload.sourceUrlLocally,
			};
		case CreateTeaserActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case CreateTeaserActionTypes.SET_CUSTOMER:
			return {
				...state,
				selectedCustomer: action.payload.customer,
				selectedRestaurants: [],
				fetchedRestaurants: [],
				fetchedDishCategories: [],
				selectedTransitionDishCategory: null,
				fetchedDishSubCategories: [],
				selectedTransitionDishSubCategory: null,
				fetchedDishes: [],
				selectedTransitionDishName: null,
				fetchedGameCategories: [],
				selectedTransitionGameCategory: null,
				fetchedGames: [],
				selectedTransitionGameName: null,
			};
		case CreateTeaserActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case CreateTeaserActionTypes.SET_RESTAURANTS:
			return {
				...state,
				selectedRestaurants: action.payload.restaurants,
				fetchedDishCategories: [],
				selectedTransitionDishCategory: null,
				fetchedDishSubCategories: [],
				selectedTransitionDishSubCategory: null,
				fetchedDishes: [],
				selectedTransitionDishName: null,
				fetchedGameCategories: [],
				selectedTransitionGameCategory: null,
				fetchedGames: [],
				selectedTransitionGameName: null,
			};
		case CreateTeaserActionTypes.SET_CONTENT_TYPE:
			return {
				...state,
				sourceUrlLocally: null,
				fileId: null,
				selectedContentType: action.payload.contentType,
				schedule: '',
				totalSchedules: [],
				selectedTransitionType: null,
				selectedTransitionDishCategory: null,
				selectedTransitionDishSubCategory: null,
				selectedTransitionDishName: null,
				selectedTransitionGameCategory: null,
				selectedTransitionGameName: null,
				selectedControlPoint: null,
				delayTime: '',
				launchCount: '',
				countDown: '',
			};
		case CreateTeaserActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case CreateTeaserActionTypes.CHANGE_SCHEDULE:
			return {
				...state,
				schedule: action.payload.schedule,
			};
		case CreateTeaserActionTypes.CHANGE_ADDITIONAL_SCHEDULE:
			return {
				...state,
				totalSchedules: action.payload.updatedSchedules,
			};
		case CreateTeaserActionTypes.SET_SCHEDULES:
			return {
				...state,
				totalSchedules: action.payload.updatedSchedules,
			};
		case CreateTeaserActionTypes.SET_TRANSITION_TYPE:
			return {
				...state,
				selectedTransitionType: action.payload.transitionType,
				selectedTransitionDishCategory: null,
				selectedTransitionDishSubCategory: null,
				selectedTransitionGameName: null,
				selectedTransitionGameCategory: null,
				selectedTransitionDishName: null,
			};
		case CreateTeaserActionTypes.SET_FETCHED_DISH_CATEGORIES:
			return {
				...state,
				fetchedDishCategories: action.payload.dishCategories,
			};
		case CreateTeaserActionTypes.SET_TRANSITION_DISH_CATEGORY:
			return {
				...state,
				selectedTransitionDishCategory: action.payload.transitionDishCategory,
				fetchedDishSubCategories: [],
				selectedTransitionDishSubCategory: null,
				fetchedDishes: [],
				selectedTransitionDishName: null,
			};
		case CreateTeaserActionTypes.SET_FETCHED_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedDishSubCategories: action.payload.dishSubCategories,
			};
		case CreateTeaserActionTypes.SET_TRANSITION_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedTransitionDishSubCategory: action.payload.transitionDishSubCategory,
				fetchedDishes: [],
				selectedTransitionDishName: null,
			};
		case CreateTeaserActionTypes.SET_FETCHED_DISHES:
			return {
				...state,
				fetchedDishes: action.payload.dishes,
			};
		case CreateTeaserActionTypes.SET_TRANSITION_DISH_NAME:
			return {
				...state,
				selectedTransitionDishName: action.payload.transitionDishName,
			};
		case CreateTeaserActionTypes.SET_FETCHED_GAME_CATEGORIES:
			return {
				...state,
				fetchedGameCategories: action.payload.gameCategories,
			};
		case CreateTeaserActionTypes.SET_TRANSITION_GAME_CATEGORY:
			return {
				...state,
				selectedTransitionGameCategory: action.payload.transitionGameCategory,
				fetchedGames: [],
				selectedTransitionGameName: null,
			};
		case CreateTeaserActionTypes.SET_FETCHED_GAMES:
			return {
				...state,
				fetchedGames: action.payload.games,
			};
		case CreateTeaserActionTypes.SET_TRANSITION_GAME_NAME:
			return {
				...state,
				selectedTransitionGameName: action.payload.transitionGameName,
			};
		case CreateTeaserActionTypes.SET_CONTROL_POINT:
			return {
				...state,
				selectedControlPoint: action.payload.controlPoint,
			};
		case CreateTeaserActionTypes.CHANGE_DELAY_TIME:
			return {
				...state,
				delayTime: action.payload.delayTime,
			};
		case CreateTeaserActionTypes.CHANGE_LAUNCH_COUNT:
			return {
				...state,
				launchCount: action.payload.launchCount,
			};
		case CreateTeaserActionTypes.CHANGE_COUNTDOWN:
			return {
				...state,
				countDown: action.payload.countDown,
			};
		case CreateTeaserActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateTeaserActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateTeaserActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				sourceUrlLocally: null,
				fetchedCustomers: [],
				selectedCustomer: null,
				fetchedRestaurants: [],
				selectedRestaurants: [],
				selectedContentType: null,
				description: '',
				schedule: '',
				totalSchedules: [],
				selectedTransitionType: null,
				fetchedDishCategories: [],
				selectedTransitionDishCategory: null,
				fetchedDishSubCategories: [],
				selectedTransitionDishSubCategory: null,
				fetchedDishes: [],
				selectedTransitionDishName: null,
				fetchedGameCategories: [],
				selectedTransitionGameCategory: null,
				fetchedGames: [],
				selectedTransitionGameName: null,
				selectedControlPoint: null,
				delayTime: '',
				launchCount: '',
				countDown: '',
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
